import { Controller } from '@hotwired/stimulus';
import { application } from 'src';

application.register(
  'trip-incident-occurrence',
  class extends Controller {
    static targets = ['field', 'line'];

    connect() {
      if (this.lineTarget.value && this.#areFieldsEmpty()) this.#requestTripIncidentData();

      $(this.lineTarget).on('change.select2:select', () => this.#requestTripIncidentData())
    }

    #setTripIncidentDataResult(element, value) {
      $(element).val(value).trigger('change');
    }

    #requestTripIncidentData() {
      fetch(`/admin/lines/${this.lineTarget.value}/trip_incident_data`)
        .then(response => {
          response.json().then(result => {
            this.fieldTargets.forEach(element => {
              this.#setTripIncidentDataResult(element, result[element.dataset.key])
            });
          })
        })
    }

    #areFieldsEmpty() {
      return this.fieldTargets.every(field => !field.value);
    }
  }
)
